export default __webpack_public_path__ + "static/media/student_registration_template.78f36a8e.xlsx";